export const noticeInitData: NoticeRegisterType = {
  needModifyData: true,
  currentCategory: 1301000,
  title: "",
  contents: "",
  stores: [],
  beforeStores: [],
  tempStores: [],
  deleteTempStore: [],
  dateToggle: false,
  endDate: "",
  importNotice: false,
  fileList: [],
  imageList: [],
  limitImage: 3,
};

export const category = [
  { value: "1301000", name: "일반공지" },
  { value: "1302000", name: "마네킨 착장" },
  { value: "1303000", name: "매장연출" },
  { value: "1304000", name: "영상" },
  { value: "1305000", name: "비주얼" },
  { value: "1306000", name: "기타" },
];
